import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { RacingModuleDataObj, WVMain, WVRacing } from '../wallboard-view.model';
import { RacingSetupTransferObj } from '../../wallboards.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-wallboard-view-racing',
  templateUrl: './wallboard-view-racing.component.html',
  styleUrls: ['./wallboard-view-racing.component.scss']
})
export class WallboardViewRacingComponent implements OnInit, OnDestroy {
    @Input() firstSlide;

    public wvf: WVMain;
    public wvrf: WVRacing;
    public racingState: RacingSetupTransferObj;
    public racingData: RacingModuleDataObj[];
    private updateTimerRef: NodeJS.Timeout = null;

    private $slideContainer: JQuery<HTMLElement>;
    private usedInts: number[] = [];
    public theme: string = "";
    public racer: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    public localization: Map<string, string>;

    private isDestroyed: boolean = false;
    private _moduleKey: string = "";

    get moduleKey(): string {
        return this._moduleKey;
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
        private localizationService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.localizationService.GetSection('Wallboard_Management');

        this.wvf = this.service.WVMain;
        this.wvrf = this.service.WVRacing;

        this._moduleKey = this.wvrf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";

        for (let i = 0; i < this.racer.length; i++) {
            this.racer[i] = this.getRandomInt(1, 10);
        }

        let typeState = this.wallboardsService.loadTypeState(2, this.wvrf.Slide.WallboardModuleDetails[0].WallboardModuleKey, this.wvf.WallboardCreatorID).then(response => {
            if (this.isDestroyed)
                return;

            this.racingState = response.Racing_Setup;
        });

        let moduleData = this.service.getRacingModuleData(this.wvrf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.racingData = response;
        });

        let metricName = this.service.getMetricName(this.wvrf.Slide.WallboardID, this.moduleKey);

        Promise.all([typeState, moduleData, metricName]).then(responses => {
            this.racingState.MetricDisplayName = responses[2];

            this.wvf.RunSlide = this.firstSlide;

            if (this.firstSlide)
                this.wvf.FirstSlideReady = true; // First one also needs the runslide thing?
            else
                this.wvf.NextSlideReady = true;

            this.$slideContainer = angular.element(document).find('.wallboardViewSlide');
            this.setUpSlideData();
        });
    }

    ngOnDestroy(): void {
        // End data updates
        if (this.updateTimerRef != null)
            clearInterval(this.updateTimerRef);

        this.isDestroyed = true;
    }

    /**
     * Gets image for racing theme of specified type.
     * @param type 1 = Background, 2 = Header, 3 = Target Board
     */
    getRacingImage(type: number) {
        if (!this.racingState)
            return "none";

        let fileName = "";
        // Set race background based on theme
        switch (this.racingState.Theme) {
            case 'Rocket Race':
                switch (type) {
                    case 1:
                        fileName = "Background-Rockets.png";
                        break;
                    case 2:
                        fileName = "Header-Rockets.png";
                        break;
                    case 3:
                        fileName = "RocketRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Motocross':
                switch (type) {
                    case 1:
                        fileName = "Background-Bikes.png";
                        break;
                    case 2:
                        fileName = "Header-Bikes.png";
                        break;
                    case 3:
                        fileName = "BikeRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Swim Meet':
                switch (type) {
                    case 1:
                        fileName = "Background-Swimmers.png";
                        break;
                    case 2:
                        fileName = "Header-Swimming.png";
                        break;
                    case 3:
                        fileName = "SwimmerRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Horse Derby':
                switch (type) {
                    case 1:
                        fileName = "Background-Horses.png";
                        break;
                    case 2:
                        fileName = "Header-Horses.png";
                        break;
                    case 3:
                        fileName = "HorseRace_TargetBoard.png";
                        break;
                }
                break;
            case 'ATV Racing':
                switch (type) {
                    case 1:
                        fileName = "QuadRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "QuadRace_Banner.png";
                        break;
                    case 3:
                        fileName = "QuadRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Boat Racing':
                switch (type) {
                    case 1:
                        fileName = "BoatRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "BoatRace_Banner.png";
                        break;
                    case 3:
                        fileName = "BoatRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Drag Racing':
                switch (type) {
                    case 1:
                        fileName = "DragRaceBkgnd.jpg";
                        break;
                    case 2:
                        fileName = "DragRace_Banner.png";
                        break;
                    case 3:
                        fileName = "DragRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Formula One Racing':
                switch (type) {
                    case 1:
                        fileName = "FormulaOneRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "FormulaOneRace_Banner.png";
                        break;
                    case 3:
                        fileName = "FormulaOneRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Jet Racing':
                switch (type) {
                    case 1:
                        fileName = "JetRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "JetRace_Banner.png";
                        break;
                    case 3:
                        fileName = "JetRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Truck Racing':
                switch (type) {
                    case 1:
                        fileName = "MonsterTruckRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "MonsterTruckRace_Banner.png";
                        break;
                    case 3:
                        fileName = "MonsterTruckRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Raptor Racing':
                switch (type) {
                    case 1:
                        fileName = "RaptorRacer_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "RaptorRace_Banner.png";
                        break;
                    case 3:
                        fileName = "RaptorRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Snail Racing':
                switch (type) {
                    case 1:
                        fileName = "SnailRacer_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "SnailRace_Banner.png";
                        break;
                    case 3:
                        fileName = "SnailRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Snowmobile Racing':
                switch (type) {
                    case 1:
                        fileName = "SnowmobileRacer_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "SnowmobileRace_Banner.png";
                        break;
                    case 3:
                        fileName = "SnowmobileRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Street Racing':
                switch (type) {
                    case 1:
                        fileName = "StreetRacer_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "StreetRace_Banner.png";
                        break;
                    case 3:
                        fileName = "StreetRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Tortoise And Hare Racing':
                switch (type) {
                    case 1:
                        fileName = "TortoiseAndHareRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "TortoiseAndHareRace_Banner.png";
                        break;
                    case 3:
                        fileName = "TortoiseAndHareRace_TargetBoard.png";
                        break;
                }
                break;
            case 'UFO Racing':
                switch (type) {
                    case 1:
                        fileName = "UFORace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "UFO-Race_Banner.png";
                        break;
                    case 3:
                        fileName = "UFO-Race_TargetBoard.png";
                        break;
                }
                break;
            case 'Train Racing':
                switch (type) {
                    case 1:
                        fileName = "TrainRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "TrainRace_Banner.png";
                        break;
                    case 3:
                        fileName = "TrainRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Christmas Tree Racing':
                switch (type) {
                    case 1:
                        fileName = "ChristmasTreeRace_Bkgd.png";
                        break;
                    case 2:
                        fileName = "ChristmasTreeRace_Banner.png";
                        break;
                    case 3:
                        fileName = "ChristmasTreeRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Cupid Racing':
                switch (type) {
                    case 1:
                        fileName = "CupidRacers_bkgnd.png";
                        break;
                    case 2:
                        fileName = "CupidRace_Banner.png";
                        break;
                    case 3:
                        fileName = "CupidRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Easter Bunny Racing':
                switch (type) {
                    case 1:
                        fileName = "EasterBunnyRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "EasterBunnyRace_Banner.png";
                        break;
                    case 3:
                        fileName = "EasterBunnyRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Elderly Racing':
                switch (type) {
                    case 1:
                        fileName = "ElderlyRace_Bkgnd.png";
                        break;
                    case 2:
                        fileName = "ElderlyRace_Banner.png";
                        break;
                    case 3:
                        fileName = "ElderlyRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Fish Racing':
                switch (type) {
                    case 1:
                        fileName = "FishRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "FishRace_Banner.png";
                        break;
                    case 3:
                        fileName = "FishRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Robot Racing':
                switch (type) {
                    case 1:
                        fileName = "RobotRace_Bkgnd.png";
                        break;
                    case 2:
                        fileName = "RobotRace_Banner.png";
                        break;
                    case 3:
                        fileName = "RobotRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Sleigh Ride Racing':
                switch (type) {
                    case 1:
                        fileName = "SleighrideRace_Bkgnd.png";
                        break;
                    case 2:
                        fileName = "SleighrideRace_Banner.png";
                        break;
                    case 3:
                        fileName = "SleighrideRace_TargetBoard.png";
                        break;
                }
                break;
            case 'St Patricks Day Racing':
                switch (type) {
                    case 1:
                        fileName = "StPatricksDayRace_Bkgnd.png";
                        break;
                    case 2:
                        fileName = "StPatricksDayRace_Banner.png";
                        break;
                    case 3:
                        fileName = "StPatricksDayRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Super Racing':
                switch (type) {
                    case 1:
                        fileName = "SuperRace_Banner.png";
                        break;
                    case 2:
                        fileName = "SuperRace_Banner.png";
                        break;
                    case 3:
                        fileName = "SuperRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Turkey Racing':
                switch (type) {
                    case 1:
                        fileName = "TurkeyRace_Bkgnd.png";
                        break;
                    case 2:
                        fileName = "TurkeyRace_Banner.png";
                        break;
                    case 3:
                        fileName = "TurkeyRace_TargetBoard.png";
                        break;
                }
                break;
            case 'Zombie Racing':
                switch (type) {
                    case 1:
                        fileName = "ZombieRace_Bkgnd.jpg";
                        break;
                    case 2:
                        fileName = "ZombieRace_Banner.png";
                        break;
                    case 3:
                        fileName = "ZombieRace_TargetBoard.png";
                        break;
                }
                break;
            case 'St Patricks Day Racing 2':
                switch (type) {
                    case 1:
                        fileName = "StPatricksDayRace2_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "StPatricksDayRace2_Banner.svg";
                        break;
                    case 3:
                        fileName = "StPatricksDayRace2_TargetBoard.svg";
                        break;
                }
                break;
            case 'Thanksgiving Racing 1':
            case 'Thanksgiving Racing 2':
                switch (type) {
                    case 1:
                        fileName = "ThanksgivingRace1_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "ThanksgivingRace1_Banner.svg";
                        break;
                    case 3:
                        fileName = "ThanksgivingRace1_TargetBoard.svg";
                        break;
                }
                break;
            case 'Easter Racing 2':
                switch (type) {
                    case 1:
                        fileName = "EasterRace2_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "EasterRace2_Banner.svg";
                        break;
                    case 3:
                        fileName = "EasterRace2_TargetBoard.svg";
                        break;
                }
                break;
            case 'Valentine Racing 1':
                switch (type) {
                    case 1:
                        fileName = "ValentineRace1_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "ValentineRace1_Banner.svg";
                        break;
                    case 3:
                        fileName = "ValentineRace1_TargetBoard.svg";
                        break;
                }
                break;
            case 'Candy Land Racing':
                switch (type) {
                    case 1:
                        fileName = "CandyLand_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "CandyLand_Banner.svg";
                        break;
                    case 3:
                        fileName = "CandyLand_TargetBoard.svg";
                        break;
                }
                break;
            case 'Christmas Carol Racing':
                switch (type) {
                    case 1:
                        fileName = "ChristmasCarolRace_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "ChristmasCarolRace_Banner.svg";
                        break;
                    case 3:
                        fileName = "ChristmasCarolRace_TargetBoard.svg";
                        break;
                }
                break;
            case 'Halloween Racing 1':
                switch (type) {
                    case 1:
                        fileName = "HalloweenRace1_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "HalloweenRace1_Banner.svg";
                        break;
                    case 3:
                        fileName = "HalloweenRace1_TargetBoard.svg";
                        break;
                }
                break;
            case 'Jungle Racing 1':
                switch (type) {
                    case 1:
                        fileName = "JungleRace1_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "JungleRace1_Banner.svg";
                        break;
                    case 3:
                        fileName = "JungleRace1_TargetBoard.svg";
                        break;
                }
                break;
            case 'Jungle Racing 2':
                switch (type) {
                    case 1:
                        fileName = "JungleRace2_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "JungleRace2_Banner.svg";
                        break;
                    case 3:
                        fileName = "JungleRace2_TargetBoard.svg";
                        break;
                }
                break;
            case 'Mask Racing':
                switch (type) {
                    case 1:
                        fileName = "MaskRace_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "MaskRace_Banner.svg";
                        break;
                    case 3:
                        fileName = "MaskRace_TargetBoard.svg";
                        break;
                }
                break;
            case 'Plant Racing':
                switch (type) {
                    case 1:
                        fileName = "PlantRace_Bkgnd.svg";
                        break;
                    case 2:
                        fileName = "PlantRace_Banner.svg";
                        break;
                    case 3:
                        fileName = "PlantRace_TargetBoard.svg";
                        break;
                }
                break;
            default:
                return "none";
        }

        return `url('../App_Themes/Standard/Images/Wallboards/WallboardView/Racing-Headers-and-Backgrounds/${fileName}')`;
    }

    setUpSlideData() {
        if (this.racingState.Theme == "Random") // Currently 28 available themes
            this.setRandomTheme();
            
        // Adjust alignment, size, and color of items on the race module based on theme  
        switch (this.racingState.Theme) {
            case 'Rocket Race':
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#8DC348");
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-8%' });
                break;
            case 'Motocross':
                this.$slideContainer.find(".wallboardViewTitle:last").last().css("top", "17%");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-49vw', 'top': '7.5vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '100%', 'top': '-14%' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '100%', 'top': '-13%' });
                break;
            case 'Swim Meet':
                this.$slideContainer.find(".wallboardViewTitle").last().css("top", "7%");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-42vw', 'top': '7vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '100%', 'top': '-14%' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '100%', 'top': '-13%' });
                break;
            case 'Horse Derby':
                this.$slideContainer.find(".wallboardViewTitle").last().css("top", "-3%");
                this.$slideContainer.find(".wallboardViewHeader").last().css("top", "3%");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-49vw', 'top': '13vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '100%', 'top': '-14%' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '100%', 'top': '-13%' });
                break;
            case 'ATV Racing':
                this.$slideContainer.find(".wvBannerTitle").last().css("color", "#000");
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000");
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '80%', 'top': '-10%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '80%', 'top': '-15%', 'font-size': '4vh' });
                break;
            case 'Boat Racing':
                this.$slideContainer.find(".wvBannerTitle").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-44vw', 'top': '2vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '100%', 'top': '-12%', 'color': '#000', 'font-size': '2.5vh' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '100%', 'top': '-16%', 'font-size': '3vh', 'color': 'gray' });
                break;
            case 'Drag Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '3%', 'height': '22.4vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "86%" });
                this.$slideContainer.find(".wvBannerTitle").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-60vw', 'top': '4.7vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '99%', 'top': '-15%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '99%', 'top': '-13%' });
                break;
            case 'Formula One Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '3%', 'height': '22.4vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "86%" });
                this.$slideContainer.find(".wvBannerTitle").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-60vw', 'top': '4.7vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '99%', 'top': '-15%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '99%', 'top': '-13%' });
                break;
            case 'Jet Racing':
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "77%" });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-49vw', 'top': '2vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '100%', 'top': '-7%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '100%', 'top': '-12%', 'color': 'gray', 'font-size': '3vh' });
                break;
            case 'Truck Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '1%' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "90%" });
                this.$slideContainer.find(".wvBannerTitle").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ 'color': '#000' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-59vw', 'top': '9vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '99%', 'top': '-13%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '99%', 'top': '-12%' });
                break;
            case 'Raptor Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'top': '6%', 'left': '1%' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "89%", 'top': '6%', 'color': '#000' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ 'width': '69%', 'margin': 'auto' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ 'width': '68%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-53vw', 'top': '2vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '86%' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '86%', 'top': '-5%' });
                break;
            case 'Snail Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'top': '4%', 'left': '4%' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ 'width': '64%', "color": "#000", 'margin': 'auto' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ 'width': '69%', "color": "#000" });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-59vw', 'top': '6vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '64%', 'top': '-23%', 'color': '#000', 'font-size': '2vh' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '64%', 'top': '-26%', 'font-size': '4vh' });
                break;
            case 'Snowmobile Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'top': '6%', 'left': '2%' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "92%", 'top': '9%' });
                this.$slideContainer.find(".wvBannerTitle").last().css("color", "#000");
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-63vw', 'top': '3vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '86%', 'top': '-2%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '86%', 'top': '-8%' });
                break;
            case 'Street Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css("width", "36vw");
                this.$slideContainer.find(".wvBannerTitle").last().css("color", "#000");
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-53vw', 'top': '8vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '99%', 'top': '-10%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '99%', 'top': '-14%', 'font-size': '6vh' });
                break;
            case 'Tortoise And Hare Racing':
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000", "width": "90%", "margin": "0 5% 0 2%" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000");
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'width': '80%', 'top': '-10%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'width': '80%', 'top': '-15%', 'font-size': '4vh' });
                break;
            case 'UFO Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '2%' });
                this.$slideContainer.find(".wvBannerTitle").last().css("color", "#000");
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-57vw' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-14%', 'right': '-4%', 'color': '#000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-10%', 'right': '-4%' });
                break;
            case 'Train Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '2%' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "89%", 'top': '16%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-57vw', 'top': '9vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-14%' });
                this.$slideContainer.find(".wvRaceTarget").last().css("top", "-13%");
                this.$slideContainer.find(".wvBannerTitle").last().css("color", "#FACC00");
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#FACC00");
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'color': '#FACC00' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'color': '#FACC00' });
                break;
            case 'Christmas Tree Racing':
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-45vw', 'top': '-1vh', 'width': '17vw', 'height': '13vw' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000000");
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-3vw', "color": "#F2F2F2" });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3.5vw', 'color': '#000000', 'font-size': '2.5vh' });
                break;
            case 'Cupid Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'top': '1vh' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css("color", "#000000");
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-47vw', 'top': '3vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'left': '1vw', 'top': '-2vh', 'color': '#000000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'left': '1vw', 'top': '-2vh', "color": "#F6FAFD" });
                break;
            case 'Easter Bunny Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '3vw' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "92%", "color": "#000000" });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '3vw' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-62vw', 'top': '3vh', 'width': '20vw', 'height': '20vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-5vh', 'width': '76%', "color": "#000000" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-4vh', 'width': '76%', 'color': '#F6FAFD' });
                break;
            case 'Elderly Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '4vw' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000", 'font-size': '7vh' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '7vh' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-56vw', 'top': '-5vh', 'width': '20vw', 'height': '20vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '1.5vh', 'color': '#000000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '2.5vh', 'width': '84%', 'color': '#F6FAFD' });
                break;
            case 'Fish Racing':
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000", 'font-size': '5vh' });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '5vh' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-44vw', 'top': '1vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'color': '#000000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'color': '#687582' });
                break;
            case 'Robot Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '2vw', 'top': '1vh' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '5vh' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-56vw', 'top': '-1vh', 'width': '20vw' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'color': '#000000' });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '1vh', 'color': '#F6FAFD' });
                break;
            case 'Sleigh Ride Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '1vw', 'top': '1vh' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#FFF0DE" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#FFF0DE", 'font-size': '5vh' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-58vw', 'top': '8vh', 'width': '20vw' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-2vh', "color": "#FFF0DE" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-2.5vh', "color": "#FFF0DE" });
                break;
            case 'St Patricks Day Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '2vw' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "86%", 'font-size': '2.5vw', "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '2.5vw' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-63vw', 'top': '-2vh', 'width': '20vw', 'height': '26vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-4vh', "color": "#000000" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-3vh', 'color': '#F6FAFD' });
                break;
            case 'Super Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '5vw' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "89%", "color": "#000000" });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '3vw' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-61vw', 'top': '2vh', 'width': '20vw', 'height': '20vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-5vh', 'width': '75%', "color": "#000000" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-4vh', 'width': '75%', 'color': '#F6FAFD' });
                break;
            case 'Turkey Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '2vw' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#000000" });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ "width": "89%", 'font-size': '2.5vw', "color": "#000000" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#000000", 'font-size': '3vw' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-61vw', 'top': '0vh', 'width': '20vw', 'height': '25vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-4vh', "color": "#000000" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-3vh', 'color': '#F6FAFD' });
                break;
            case 'Zombie Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '4vw', 'top': '1vh', 'width': '33vw' });
                this.$slideContainer.find(".wvBannerTitle").last().css({ "color": "#FFF0DE" });
                this.$slideContainer.find(".wvMetricDisplayName").last().css({ "color": "#FFF0DE", 'font-size': '3vw' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-58vw', 'top': '2vh', 'width': '20vw', 'height': '20vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-4vh', "color": "#FFF0DE" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-2vh', "color": "#FFF0DE" });
                break;
            case 'St Patricks Day Racing 2':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '5vw', 'top': '-1vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#748415", 'left': '1vw', 'width': '94%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#748415" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-5vh', 'color': '#748415' });
                break;
            case 'Thanksgiving Racing 1':
            case 'Thanksgiving Racing 2':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '10vw', 'top': '-4vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#FFFFFA", 'top': '7vh', 'left': '0.5vw', 'width': '95%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-6.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#FFFFFA" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-5vh', 'color': '#FFFFFA' });
                break;
            case 'Easter Racing 2':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '8vw', 'top': '-1vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#5D3367", 'left': '1vw', 'width': '94%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#5D3367" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-5vh', 'color': '#5D3367' });
                break;
            case 'Valentine Racing 1':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '11vw', 'top': '-5vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#ED2965", 'top': '8vh', 'left': '0.5vw', 'width': '94%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-6.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#ED2965" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-5vh', 'color': '#ED2965' });
                break;
            case 'Candy Land Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '12vw', 'top': '-2.5vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#474746", 'top': '6vh', 'left': '1.5vw', 'width': '94%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-7vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#474746", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-4vh', 'color': '#474746', "width": "100%" });
                break;
            case 'Christmas Carol Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '10vw', 'top': '-2.5vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#FFFFFF", 'top': '6vh', 'left': '1vw', 'width': '94%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-6.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#FFFFFF", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-5vh', 'color': '#FFFFFF', "width": "100%" });
                break;
            case 'Halloween Racing 1':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '9vw', 'top': '-4vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#F9DE69", 'top': '6.5vh', 'left': '2.5vw', 'width': '90%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-5.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-3vh', "color": "#F9DE69", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-5vh', 'color': '#F9DE69', "width": "100%" });
                break;
            case 'Jungle Racing 1':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '14vw', 'top': '-4vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#000000", 'top': '11.5vh', 'left': '2vw', 'width': '89%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-38vw', 'top': '-10.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-1vh', "color": "#000000", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-3.5vh', 'color': '#000000', "width": "100%" });
                break;
            case 'Jungle Racing 2':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '14vw', 'top': '-5vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#FFFFFF", 'top': '12.5vh', 'left': '2vw', 'width': '89%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-32vw', 'top': '-10.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-1vh', "color": "#FFFFFF", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-3.5vh', 'color': '#FFFFFF', "width": "100%" });
                break;
            case 'Mask Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '-1.5vw', 'top': '-0.5vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '2vw', "color": "#FCF79D", 'text-shadow': '-2px 2px #000000', 'top': '4vh', 'left': '14vw', 'width': '63%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-33vw', 'top': '-4vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-5vh', "color": "#C7F9F9", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-7vh', 'color': '#C7F9F9', "width": "100%" });
                break;
            case 'Plant Racing':
                this.$slideContainer.find(".wallboardViewHeader").last().css({ 'left': '20vw', 'top': '-3vh' });
                this.$slideContainer.find(".wallboardViewTitle").last().css({ 'font-size': '3vw', "color": "#606060", 'top': '5.5vh', 'left': '2vw', 'width': '89%' });
                this.$slideContainer.find(".wvRaceTargetBoard").last().css({ 'right': '-25vw', 'top': '-3.5vh', 'width': '20vw', 'height': '30vh' });
                this.$slideContainer.find(".wvTargetTitle").last().css({ 'top': '-5vh', "color": "#606060", "width": "100%" });
                this.$slideContainer.find(".wvRaceTarget").last().css({ 'top': '-7vh', 'color': '#606060', "width": "100%" });
                break;
            default:
                break;
        }

        // If this slide is not the first slide, let WallboardViewMain know that this slide is ready to run.
        if (!this.firstSlide) 
            this.wvf.NextSlideReady = true;
        else
            this.wvf.FirstSlideReady = true;
        setTimeout(() => {
            this.startRace();
        }, 0);
    }

    // This function is used to randomly assign a racer and prevent any duplicates.
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        let num = Math.floor(Math.random() * (max - min + 1)) + min;
        let dup = false;

        if (this.usedInts != undefined) {
            for (let i = 0; i < this.usedInts.length; i++) {
                if (num == this.usedInts[i])
                    dup = true;
            }

            if (dup)
                return this.getRandomInt(1, 10);
            else {
                this.usedInts.push(num);
                return num;
            }
        }
        else {
            this.usedInts = [num];
            return num;
        }
    }

    startRace() {
        if (this.wvf.RunSlide) {
            // End data updates
            if (this.updateTimerRef != null)
                clearInterval(this.updateTimerRef);

            // This is last minute set up items such as height of racing lanes, trail and text colors (based on theme).
            setTimeout(() => {
                this.$slideContainer.find(".racingLane").css("height", `calc(65vh / ${this.racingData.length})`);

                switch (this.racingState.Theme) {
                    case 'Rocket Race':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#3A3A3C");
                        this.$slideContainer.find(".teamName").css("color", "#8DC348");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#FFF");
                        break;
                    case 'Motocross':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#5B4438");
                        this.$slideContainer.find(".teamName").css("color", "#FFF");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#FFF");
                        break;
                    case 'Swim Meet':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#83D5F7");
                        break;
                    case 'Horse Derby':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#9FD073");
                        break;
                    case 'ATV Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F2C9AD");
                        break;
                    case 'Boat Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#B5FFFF");
                        break;
                    case 'Drag Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#E6E7E9");
                        break;
                    case 'Formula One Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#E0D6CC");
                        break;
                    case 'Jet Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F2F2F2");
                        break;
                    case 'Truck Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F2C9AD");
                        break;
                    case 'Raptor Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F2C9AD");
                        break;
                    case 'Snail Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F2C9AD");
                        break;
                    case 'Snowmobile Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F8F9FB");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Street Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#E0D6CC");
                        break;
                    case 'Tortoise And Hare Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#F2C9AD");
                        break;
                    case 'UFO Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#414E7A");
                        this.$slideContainer.find(".teamName").css("color", "#FFF");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#FFF");
                        break;
                    case 'Train Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#575757");
                        this.$slideContainer.find(".teamName").css("color", "#FFF");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#FFF");
                        break;
                    case 'Christmas Tree Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#DEDEDE");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Cupid Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#D6F7FF");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Easter Bunny Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#9AF797");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Elderly Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#FFF1E0");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Fish Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#B4FFFF");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Robot Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#E6E6E6");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Sleigh Ride Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#FAFAFA");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'St Patricks Day Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#9AF797");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Super Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#C9B4A5");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Turkey Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#FAE0AE");
                        this.$slideContainer.find(".teamName").css("color", "#000000");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#000000");
                        break;
                    case 'Zombie Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#384F45");
                        this.$slideContainer.find(".teamName").css("color", "#B9E085");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#B9E085");
                        break;
                    case 'St Patricks Day Racing 2':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#CFE553");
                        this.$slideContainer.find(".teamName").css("color", "#748415");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#748415");
                        break;
                    case 'Thanksgiving Racing 1':
                    case 'Thanksgiving Racing 2':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#D6B95F");
                        this.$slideContainer.find(".teamName").css("color", "#7C3016");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#7C3016");
                        break;
                    case 'Easter Racing 2':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#FFFFFA");
                        this.$slideContainer.find(".teamName").css("color", "#5D3367");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#5D3367");
                        break;
                    case 'Valentine Racing 1':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#FFFFFA");
                        this.$slideContainer.find(".teamName").css("color", "#ED2965");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#ED2965");
                        break;
                    case 'Candy Land Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#FFFFFF");
                        this.$slideContainer.find(".teamName").css("color", "#474746");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#474746");
                        break;
                    case 'Christmas Carol Racing':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#237C73");
                        this.$slideContainer.find(".teamName").css("color", "#FFFFFF");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#FFFFFF");
                        break;
                    case 'Halloween Racing 1':
                        this.$slideContainer.find(".racingTrail").css("background-color", "#170319");
                        this.$slideContainer.find(".teamName").css("color", "#F9DE69");
                        this.$slideContainer.find(".wallboardViewData").css("color", "#F9DE69");
                        break;
                    case 'Jungle Racing 1':
                        this.$slideContainer.find(".racingTrail").addClass("jungleRace1Pattern");
                        this.$slideContainer.find(".teamName").css({ "color": "#000000", "position": "relative", "left": "7vw", "font-size": "1.5vw" });
                        this.$slideContainer.find(".teamNameValue").css({ "background-color": "#000000", "color": "#FFFFFF" });
                        this.$slideContainer.find(".wallboardViewData").css({ "color": "#FFFFFF", "font-size": "1.5vw", "margin-right": "40px" });
                        this.$slideContainer.find(".wallboardViewDataValue").css({ "background-color": "#000000" });
                        break;
                    case 'Jungle Racing 2':
                        this.$slideContainer.find(".racingTrail").addClass("jungleRace2Pattern");
                        this.$slideContainer.find(".teamName").css({ "color": "#000000", "position": "relative", "left": "6vw", "font-size": "1.5vw" });
                        this.$slideContainer.find(".teamNameValue").css({ "background-color": "#C3EA96", "color": "#25330E" });
                        this.$slideContainer.find(".wallboardViewData").css({ "color": "#25330E", "font-size": "1.5vw" });
                        this.$slideContainer.find(".wallboardViewDataValue").css({ "background-color": "#C3EA96" });
                        break;
                    case 'Mask Racing':
                        this.$slideContainer.find(".racingTrail").addClass("maskRacePattern");
                        this.$slideContainer.find(".teamName").css({ "color": "#C7F9F9", "font-size": "1.5vw" });
                        this.$slideContainer.find(".teamNameValue").css({ "background-color": "#603719", "color": "#FCF79D" });
                        this.$slideContainer.find(".wallboardViewData").css({ "color": "#FCF79D", "font-size": "1.5vw" });
                        this.$slideContainer.find(".wallboardViewDataValue").css({ "background-color": "#603719" });
                        break;
                    case 'Plant Racing':
                        this.$slideContainer.find(".racingTrail").addClass("plantRacePattern");
                        this.$slideContainer.find(".teamName").css({ "color": "#606060", "position": "relative", "left": "6vw", "font-size": "1.5vw" });
                        this.$slideContainer.find(".teamNameValue").css({ "background-color": "#C0EA7D", "color": "#25330E" });
                        this.$slideContainer.find(".wallboardViewData").css({ "color": "#25330E", "font-size": "1.5vw" });
                        this.$slideContainer.find(".wallboardViewDataValue").css({ "background-color": "#C0EA7D" });
                        break;
                    default:
                        break;
                }
            }, 1000);
            // Execute the race by animating the width of the racing trail.
            setTimeout(() => {
                const racerWidth = $(".racer").width() || 0;

                // max Percentage used to identify the leader.
                const maxPercentage = this.racingData.length > 0
                    ? Math.max(...this.racingData.map(item => item.percentage))
                    : 0;

                // Constants for left-themed gradual adjustment calculation.
                const baseSubtract = 100;
                const gradualAdjustmentFactor = 5;

                for (let i = 0; i < this.racingData.length; i++) {
                    let subtractPx = Math.max(Math.round(racerWidth * 0.05), 4);
                    
                    // Check for long group names and leader status to adjust subtraction value.
                    const longName = (this.racingData[i].groupName?.length || 0) > 30;
                    const isLeader = this.racingData[i].percentage === maxPercentage;

                    if (isLeader && this.racingState.Positioning === 'Leader' && longName) {
                        subtractPx = Math.max(Math.round(racerWidth * 0.05), 2);
                    }

                    const isLeftTheme = (this.racingState.Theme === 'Jungle Racing 1' ||
                                        this.racingState.Theme === 'Jungle Racing 2' ||
                                        this.racingState.Theme === 'Plant Racing');

                    let effectiveSubtract = subtractPx;

                    if (isLeftTheme) {
                        effectiveSubtract = Math.max(
                            baseSubtract - (i * gradualAdjustmentFactor),
                            30
                        );
                    }

                    const $trail = this.$slideContainer.find(`#lane${i.toString()}`).find(".racingTrail");

                    if (!isLeftTheme) {
                        if (this.racingState.Positioning == 'Target')
                            $trail.css("width", `calc(${this.racingData[i].percentage >= 100 ? 100 : ((this.racingData[i].percentage * 0.65) + 35).toString()}% - ${effectiveSubtract}px)`);

                        if (this.racingState.Positioning == 'Leader') {
                            let calculatedPercentage;
                            let finalSubtract = effectiveSubtract;

                            if (isLeader) {
                                calculatedPercentage = 100;
                                finalSubtract = 10;
                            } else {
                                calculatedPercentage = this.racingData[i].percentage >= 100 ? 100 : ((this.racingData[i].percentage * 0.70) + 30);
                            }

                            $trail.css("width", `calc(${calculatedPercentage.toString()}% - ${finalSubtract}px)`);
                        }
                    }
                    else {  //for these 3 themes the racer image is on the left hand side so the min width is being made slightly larger to account for this
                        let leftSubtract = effectiveSubtract;
                        
                        if (this.racingData[i].percentage >= 100) {
                            leftSubtract = 10; 
                        }

                        if (this.racingState.Positioning == 'Target')
                            $trail.css("width", `calc(${this.racingData[i].percentage >= 100 ? 100 : (((this.racingData[i].percentage >= 3 ? this.racingData[i].percentage : 3) * 0.75) + 40).toString()}% - ${leftSubtract}px)`); 

                        if (this.racingState.Positioning == 'Leader') {
                            let calculatedPercentage;

                            if (isLeader) {
                                calculatedPercentage = 100;
                                leftSubtract = 10; 
                            } else {
                                calculatedPercentage = this.racingData[i].percentage >= 100 ? 100 : (((this.racingData[i].percentage >= 4 ? this.racingData[i].percentage : 4) * 0.75) + 35);
                            }
                            $trail.css("width", `calc(${calculatedPercentage.toString()}% - ${leftSubtract}px)`); 
                        }
                    }
                }
            }, 1000);

            // Fade in name and data value after racers have finished moving.
            setTimeout(() => {
                this.$slideContainer.find(".teamName").fadeIn().css("display", "flex");
                this.$slideContainer.find(".wallboardViewData").fadeIn().css("display", "flex");
            }, 3250);

            // Perform slide transition 1sec prior to WallboardViewMain removing this directive (if next slide is ready).
            let timer = (this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval - (this.firstSlide ? 0 : 1)) * 1000;
        }
        else {
            // If slide is still in pre-load phase recursively call function until WallboardViewMain is ready for it to run.
            if (!this.updateTimerRef) {
                // Reload the data every 10 secs.
                this.updateTimerRef = setInterval(() => {
                    this.updateSlideData();
                }, WallboardViewService.HISTORICAL_DATA_REFRESH_INTERVAL);
            }

            setTimeout(() => {
                this.startRace();
            }, 1000);
        }
    }

    public async updateSlideData() {
        this.service.getRacingModuleData(this.wvrf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            if(!this.wvf.RunSlide)  //skip the final update if it finishes after the animation starts
                this.racingData = response;
        });
    }

    setRandomTheme() {
        let rand_num = Math.floor(Math.random() * (40)) + 1;

        switch (rand_num) {
            case 1:
                this.racingState.Theme = 'Rocket Race';
                break;
            case 2:
                this.racingState.Theme = 'Motocross';
                break;
            case 3:
                this.racingState.Theme = 'Swim Meet';
                break;
            case 4:
                this.racingState.Theme = 'Horse Derby';
                break;
            case 5:
                this.racingState.Theme = 'ATV Racing';
                break;
            case 6:
                this.racingState.Theme = 'Boat Racing';
                break;
            case 7:
                this.racingState.Theme = 'Drag Racing';
                break;
            case 8:
                this.racingState.Theme = 'Formula One Racing';
                break;
            case 9:
                this.racingState.Theme = 'Jet Racing';
                break;
            case 10:
                this.racingState.Theme = 'Truck Racing';
                break;
            case 11:
                this.racingState.Theme = 'Raptor Racing';
                break;
            case 12:
                this.racingState.Theme = 'Snail Racing';
                break;
            case 13:
                this.racingState.Theme = 'Snowmobile Racing';
                break;
            case 14:
                this.racingState.Theme = 'Street Racing';
                break;
            case 15:
                this.racingState.Theme = 'Tortoise And Hare Racing';
                break;
            case 16:
                this.racingState.Theme = 'UFO Racing';
                break;
            case 17:
                this.racingState.Theme = 'Train Racing';
                break;
            case 18:
                this.racingState.Theme = 'Christmas Tree Racing';
                break;
            case 19:
                this.racingState.Theme = 'Cupid Racing';
                break;
            case 20:
                this.racingState.Theme = 'Easter Bunny Racing';
                break;
            case 21:
                this.racingState.Theme = 'Elderly Racing';
                break;
            case 22:
                this.racingState.Theme = 'Fish Racing';
                break;
            case 23:
                this.racingState.Theme = 'Robot Racing';
                break;
            case 24:
                this.racingState.Theme = 'Sleigh Ride Racing';
                break;
            case 25:
                this.racingState.Theme = 'St Patricks Day Racing';
                break;
            case 26:
                this.racingState.Theme = 'Super Racing';
                break;
            case 27:
                this.racingState.Theme = 'Turkey Racing';
                break;
            case 28:
                this.racingState.Theme = 'Zombie Racing';
                break;
            case 29:
                this.racingState.Theme = 'St Patricks Day Racing 2';
                break;
            case 30:
                this.racingState.Theme = 'Thanksgiving Racing 1';
                break;
            case 31:
                this.racingState.Theme = 'Thanksgiving Racing 2';
                break;
            case 32:
                this.racingState.Theme = 'Easter Racing 2';
                break;
            case 33:
                this.racingState.Theme = 'Valentine Racing 1';
                break;
            case 34:
                this.racingState.Theme = 'Candy Land Racing';
                break;
            case 35:
                this.racingState.Theme = 'Christmas Carol Racing';
                break;
            case 36:
                this.racingState.Theme = 'Halloween Racing 1';
                break;
            case 37:
                this.racingState.Theme = 'Jungle Racing 1';
                break;
            case 38:
                this.racingState.Theme = 'Jungle Racing 2';
                break;
            case 39:
                this.racingState.Theme = 'Mask Racing';
                break;
            case 40:
                this.racingState.Theme = 'Plant Racing';
                break;
            default:
                break;
        }
    }

    orderBy(arr: any, value: string): any[] {
        if (!Array.isArray(arr))
            return;

        arr.sort((a:any, b:any) => {
            if(a[value] < b[value])
                return -1;
            else if (a[value] > b[value])
                return 1;
            else
                return 0;
        });

        return arr;
    }

    getClasses(index){
        return {
            'One': this.racer[index] == 1,
            'Two': this.racer[index] == 2,
            'Three': this.racer[index] == 3,
            'Four': this.racer[index] == 4,
            'Five': this.racer[index] == 5,
            'Six': this.racer[index] == 6,
            'Seven': this.racer[index] == 7,
            'Eight': this.racer[index] == 8,
            'Nine': this.racer[index] == 9,
            'Ten': this.racer[index] == 10
        }
    }
}
